// Season helpers shared by the leader tabs (components/leader/SeasonTabs.js) and the admin
// season filters (components/admin/SeasonSelect.js). A season is the year of the competition date.

/**
 * [{ year, count }] newest first + the default year. The current season is always offered;
 * default = the current season when it has items, otherwise the newest season with items,
 * otherwise the current season.
 */
export function seasonTabs(years, currentSeason) {
  const counts = new Map();
  years.forEach((year) => {
    if (year) counts.set(year, (counts.get(year) || 0) + 1);
  });
  if (currentSeason && !counts.has(currentSeason)) counts.set(currentSeason, 0);
  const tabs = [...counts.entries()].map(([year, count]) => ({ year, count })).sort((a, b) => b.year - a.year);
  const withItems = tabs.filter((t) => t.count > 0);
  let defaultYear = currentSeason || null;
  if (!currentSeason || !counts.get(currentSeason)) defaultYear = withItems[0]?.year ?? currentSeason ?? null;
  return { tabs, defaultYear };
}

/** Season (year) of an ISO date string "2027-03-21" -> 2027. */
export const seasonOfDate = (iso) => Number(String(iso || '').slice(0, 4)) || null;
